<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row mb-4">
              <h4 class="ml-2">Blog Notification</h4>
            </div>
            <div class="row">
              <div class="col-8 col-sm-8">
                <form class="search-form" @submit.prevent="doSearch()">
                  <div class="input-group border rounded-sm">
                    <el-input v-model="search.search" clearable size="small" prefix-icon="el-icon-search" placeholder="Search..."></el-input>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="card-body">
            <el-button
              size="small"
              type="primary"
              class="btn-primary mb-3"
              icon="el-icon-plus"
              @click="$router.push({ name: 'Add Notification Blogs' })"
            >
              Add Blogs
            </el-button>
            <div class="table-responsive">
              <table class="table table-hover" v-loading="loading.table">
                <thead>
                  <tr>
                    <th class="w-20">Header</th>
                    <th class="w-20">Sub Header</th>
                    <th class="w-20">Tags</th>
                    <th class="w-20">Status</th>
                    <th class="w-20">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in rows" :key="i">
                    <td>{{ item.header_truncate }}</td>
                    <td>{{ item.sub_header_truncate }}</td>
                    <td>
                      <span class="badge badge-secondary pb-2">
                        {{ item.tags }}
                      </span>
                    </td>
                    <td><span style="padding: 6px" class="badge ml-1" :class="item.status_color">{{ displayStatusNotification(item) }}</span></td>
                    <td>
                      <el-tooltip content="Detail" placement="top" popper-class="fit-tooltip">
                        <button
                          class="btn btn-outline-secondary m-1"
                          @click="$router.push({ name: 'Detail Notification Blogs', params: { id: item._id } })"
                        >
                          <i class="mdi mdi-eye"></i>
                      </button>
                      </el-tooltip>
                      <el-tooltip content="Publish" placement="top" popper-class="fit-tooltip">
                        <button class="m-1 btn btn-outline-warning" v-if="(isNotificationExpired(item) && item.status === 'published') || item.status === 'draft'" @click="publishNotifBlog(item._id)"><i class="mdi mdi-publish"></i></button>
                      </el-tooltip>
                      <el-tooltip content="Unpublish" placement="top" popper-class="fit-tooltip">
                        <button class="m-1 btn btn-outline-success" v-if="(item.status === 'publish' || item.published_stop === null) || (!isNotificationExpired(item) && item.status === 'published')" @click="unPublishNotifBlog(item._id)"><i class="mdi mdi-check"></i></button>
                      </el-tooltip>
                      <el-tooltip content="Edit" placement="top" popper-class="fit-tooltip">
                        <button
                          class="btn btn-outline-primary m-1"
                          @click="$router.push({ name: 'Edit Notification Blogs', params: { id: item._id } })"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </button>
                      </el-tooltip>
                      <el-tooltip content="Responses" placement="top" popper-class="fit-tooltip">
                        <button
                          class="btn btn-outline-info m-1"
                          v-if="['rsvp', 'poll'].includes(item.cta_type)"
                          @click="$router.push({ name: 'Notification Blogs Responses', params: { id: item._id } })"
                        >
                          <i class="mdi mdi-account-multiple-check"></i>
                        </button>
                      </el-tooltip>
                      <el-tooltip content="Delete" placement="top" popper-class="fit-tooltip">
                        <button class="m-1 btn btn-outline-danger" @click="deleteNotifBlog(item._id)"><i class="mdi mdi-trash-can"></i></button>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="!rows.length" description="No data"></el-empty>
            </div>
            <b-pagination v-if="total_row > search.per_page" v-model="currentPage" :total-rows="total_row" :per-page="search.per_page"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import blogNotifApi from '../../api/blogNotif';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Notification Blogs',
  metaInfo: {
    title: 'Notification Blogs',
  },
  data() {
    return {
      moment,
      loading: {
        table: false,
        delete: false,
        publish: false,
        unpublish: false,
        update: false,
      },
      show_modal: {
        update: false,
      },
      rows: [],
      total_row: 0,
      form: {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      },
      search: {
        search: '',
        page: this.$route.query?.page || 1,
        per_page: this.$route.query?.per_page || 10,
      },
      active_reseller_id: '',
      sof: [],
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.search.page;
      },
      set(val) {
        this.search.page = val;
        this.getList();
      },
    },
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    doSearch() {
      this.page = 1;
      this.search.page = 1;
      this.search.per_page = 10;
      this.getList();
    },
    async getList() {
      this.loading.table = true;
      await blogNotifApi.getList(this.search.page, this.search.search).then(({ data }) => {
        this.total_row = data.total;
        this.rows = data.rows.map((v) => {
          const isExpired = this.isNotificationExpired(v);
          v.status_color = 'badge-success';
          if (v.status === 'draft' || (v.status === 'published' && isExpired)) {
            v.status_color = 'badge-warning';
          } else {
            v.status_color = 'badge-success';
          }
          // if (v.status === 'draft') {
          //   v.status_color = 'badge-warning';
          // }
          v.header_truncate = v.header;
          if (v.header.length > 35) {
            v.header_truncate = `${v.header.substr(0, 32)}...`;
          }
          v.sub_header_truncate = v.sub_header;
          if (v.sub_header.length > 35) {
            v.sub_header_truncate = `${v.sub_header.substr(0, 32)}...`;
          }
          return v;
        });
        this.rows = data.rows;
      });
      this.loading.table = false;
    },
    edit(item) {
      this.form = {
        name: item.name,
        email: item.email,
        address: item.address,
        reseller_id: item._id,
        payment_method: {
          id: item.payment_method?.id,
          name: item.payment_method?.name,
        },
      };
      this.show_modal.update = true;
    },
    addShow() {
      this.form = {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      };
      this.show_modal.update = true;
    },
    onHide() {
      this.form = {
        name: '',
        email: '',
        address: '',
        reseller_id: '',
        payment_method: {
          id: '',
          name: '',
        },
      };
      this.show_modal.update = false;
    },
    deleteNotifBlog(id) {
      if (!id) {
        return;
      }
      this.$confirm(this.$t('blog_notification.confirm.delete'), 'Delete this notif blog?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
      }).then(async () => {
        this.loading.delete = true;
        await blogNotifApi.delete(id).then(async (resp) => {
          await popupErrorMessages(resp);
          await this.getList();
          this.$message({
            type: 'success',
            message: this.$t('blog_notification.success.delete'),
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.message || 'Something wrong, please try again.',
          });
        });
        this.loading.delete = false;
      }).catch(() => {});
    },
    publishNotifBlog(id) {
      if (!id) {
        return;
      }
      this.$confirm(this.$t('blog_notification.confirm.published'), 'Publish this notif blog?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
      }).then(async () => {
        this.loading.delete = true;
        await blogNotifApi.publish(id).then(async (resp) => {
          await popupErrorMessages(resp);
          await this.getList();
          this.$message({
            type: 'success',
            message: this.$t('blog_notification.success.published'),
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.message || 'Something wrong, please try again.',
          });
        });
        this.loading.delete = false;
      }).catch(() => {});
    },
    unPublishNotifBlog(id) {
      if (!id) {
        return;
      }
      this.$confirm(this.$t('blog_notification.confirm.unpublished'), 'Unpublish this notif blog?', {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
      }).then(async () => {
        this.loading.delete = true;
        await blogNotifApi.unpublish(id).then(async (resp) => {
          await popupErrorMessages(resp);
          await this.getList();
          this.$message({
            type: 'success',
            message: this.$t('blog_notification.success.unpublished'),
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.response.message || 'Something wrong, please try again.',
          });
        });
        this.loading.delete = false;
      }).catch(() => {});
    },
    isNotificationExpired(item) {
      const publishedStop = item.published_stop;
      if (!publishedStop) {
        return false;
      }
      const stop = moment(publishedStop).milliseconds(0);
      const now = moment().milliseconds(0);

      return stop.diff(now, 'seconds', true) <= 0;
    },
    displayStatusNotification(item) {
      const isExpired = this.isNotificationExpired(item);

      if (item.status === 'draft') {
        return 'DRAFT';
      }

      if (item.status === 'published' && isExpired) {
        return 'DRAFT';
      }

      if (item.status === 'published') {
        return 'PUBLISHED';
      }

      return '-';
    },
  },
};
</script>
